import Model from './BaseModel';

export default class SportcastFixture extends Model {
	resourceName() {
		return 'sportcast_fixtures';
	}

	fields() {
		return ['name', 'start_time'];
	}

	updateEventMapping(eventId, data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sport_events/${eventId}/sportcast_fixture`,
			method: 'POST',
			data
		});
	}
}
